import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import View from './DefaultView';

const HomeBannerBlockView = ({ data }) => {
  return <View data={data} />;
};

export default withBlockExtensions(HomeBannerBlockView);
